import { useEffect, useState, useMemo } from 'react'
import { useSelector } from 'react-redux'
import { fetchAssetPreviewImage } from '../lib/api/assets'
import { selectors } from '../reducers/appReducer';
import noPhotoImg from '../images/no-photo.png';

export const useAssetPreviews = (filteredAssets) => {
    const [previewImages, setPreviewImages] = useState({});
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const imagePlaceholder = useSelector(selectors.getDefaultPlaceholderImage)?.imageUrl
    const imagePlaceholderUrl = imagePlaceholder === './images/no-photo.png' || imagePlaceholder === undefined ? noPhotoImg : imagePlaceholder

    const previewFileExtensionList = useSelector(selectors.getPreviewFileExtensionList) || []

    // Crea una chiave stabile per gli assets per evitare loop infiniti
    const assetsKey = useMemo(() => {
        if (!filteredAssets || filteredAssets.length === 0) return '';
        return filteredAssets.map(a => a.src).join('|');
    }, [filteredAssets])

    const checkFileExtension = (filename, extensionsList) => {
        const lowerName = filename.toLowerCase();
        return extensionsList.some(extension => lowerName.endsWith(extension));
    }

    // Nuova funzione per controllare se è un'immagine diretta (jpg, png)
    const isDirectImageFile = (filename) => {
        const lowerName = filename.toLowerCase();
        return lowerName.endsWith('.jpg') ||
            lowerName.endsWith('.jpeg') ||
            lowerName.endsWith('.png');
    }

    useEffect(() => {
        const fetchAllPreviews = async () => {
            try {
                setLoading(true);
                const previews = {};

                for (const attr of filteredAssets) {

                    if(!checkFileExtension(attr.src, previewFileExtensionList)) {
                        // Se non passa il check delle estensioni supportate per l'anteprima,
                        // ma è un'immagine diretta (jpg/png), usa l'src originale
                        if (isDirectImageFile(attr.src)) {
                            previews[attr.src] = attr.src;
                        } else {
                            previews[attr.src] = imagePlaceholderUrl;
                        }
                        continue;
                    }

                    const params = { name: attr.src }
                    const result = await fetchAssetPreviewImage(params)

                    if(!result) {
                        previews[attr.src] = imagePlaceholderUrl
                    } else {
                        previews[attr.src] = result
                    }
                }

                setPreviewImages(previews);
            } catch (err) {
                setError(err);
            } finally {
                setLoading(false);
            }
        };

        if (filteredAssets?.length > 0) {
            fetchAllPreviews()
        } else {
            // Se non ci sono assets, resetta le preview images
            setPreviewImages({});
            setLoading(false);
        }
    }, [assetsKey, imagePlaceholderUrl, previewFileExtensionList]);

    return { previewImages, loading, error };
};